import type { FeatureGroup } from '../../../types';
import { ADMINISTRATIVE_FEATURE_GROUP } from '../group';

export const SECURITY_FEATURE_GROUP: FeatureGroup = {
  guid: 'a287894e-13c7-4acc-b2e5-5b8f50af8b3f',
  name: 'security',
  description: 'Organization security policy — two-factor enforcement, allowed 2FA options, and 2FA recovery',
  product: 'account',
  parentGuid: ADMINISTRATIVE_FEATURE_GROUP.guid,
};
